// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { PortalWebAppConfiguration } from '../api/remote-api/.portal.generated/models';

export const defaultPortalWebAppConfiguration: Required<
  PortalWebAppConfiguration & {
    mrqDashboardGeneric: string;
    termsOfUseChinaPath: string;
  }
> = {
  logCompanionUrl: '/log/',

  srsUrl: 'https://crsp1.siemens.com/med/login.do',

  srsUrlCN: 'https://crsp-cn.siemens-healthineers.com/med/login.do',

  srsUrlCNWithSystemContext:
    'https://crsp-cn.siemens-healthineers.com/med/listServicedSystemCon.do?serial={systemSerialNumber}&partnumber={systemMaterialNumber}&directConnect=false',

  srsUrlWithSystemContext:
    'https://crsp1.siemens.com/med/listServicedSystemCon.do?serial={systemSerialNumber}&partnumber={systemMaterialNumber}&directConnect=false',

  skbUrl: 'https://skb.siemens-healthineers.com/pages/search/Default.aspx',

  skbUrlWithSystemContext:
    'https://skb.siemens-healthineers.com/skb-search?prod_id={systemMaterialNumber}',

  cbDocUrl: 'https://cs-pi.siemens-healthineers.com/',

  cbDocUrlWithSystemContext:
    'https://csx-pi.siemens-healthineers.com/cb-doc?sysivk={systemMaterialNumber}&cbdoctype=standard&accesstype=online',

  spcUrl:
    'https://spc.siemens-healthineers.com/OnlineSPC/showProduct.aspx?matnum={systemMaterialNumber}',

  mrqDashboardGeneric:
    'https://sdtb.siemens-healthineers.com/links/resources/report?uri=%2Freports%2Freports%2F9341e100-6865-4510-a3b3-c67c50606a86&page=vi62455',

  mrqDashboard4k:
    'https://app.powerbi.com/groups/a9a77d24-d9ef-4f02-900c-49bb494244ab/reports/b36b1c26-26cd-4d28-980b-f91a7e74ce79/a011be670224d56e4323?experience=power-bi&filter=V_MRQ_MAGNET_TABLE_4K%2fSerial_Nr_N%20eq%20{systemSerialNumber}',

  mrqDashboard10k:
    'https://app.powerbi.com/groups/a9a77d24-d9ef-4f02-900c-49bb494244ab/reports/b36b1c26-26cd-4d28-980b-f91a7e74ce79/6841a2455ce9205b649a?experience=power-bi&filter=V_MRQ_MAGNET_TABLE_10K%2fSerial_Nr_N%20eq%20{systemSerialNumber}',

  mrqDashboardDry:
    'https://app.powerbi.com/groups/a9a77d24-d9ef-4f02-900c-49bb494244ab/reports/b36b1c26-26cd-4d28-980b-f91a7e74ce79/a8620a35303742ae8a94?experience=power-bi&filter=V_MRQ_MAGNET_TABLE_DRYCOOL%2fSerial_Nr%20eq%20{systemSerialNumber}',

  seSOTeamMailAddress: 'mailto:seso.team@siemens-healthineers.com',

  naeotomDashboard:
    'https://shs.eu.qlikcloud.com/sense/app/5257d77c-337c-4b48-b37f-9c532d382d38/sheet/790ec2d1-7d38-4848-8174-7d6e14a9ce50/state/analysis/options/clearselections/select/Serial/{systemSerialNumber}',

  srsBackendWebGui: 'https://defthwa9i4msrv.ad005.onehc.net/WebGUI/Nodes.aspx',

  frequentAgentCheckTool: 'https://defthwa9i7hsrv.ad005.onehc.net/',

  docLibUrl: 'https://doclib.siemens-healthineers.com/home',

  oneLibraryUrl: 'https://siemens-healthineers.seismic.com/app#/home',

  teamplayFleetUrl: 'https://fleet.siemens-healthineers.com/welcome',

  customerDNAUrl:
    'https://app.powerbi.com/groups/me/apps/9318c981-8f99-4195-8ad8-004b5b5d4a74/reports/e5ac2066-4984-4c2c-bf35-fd56a936998f/ReportSection2f860b1fb415e4d6adc4?ctid=5dbf1add-202a-4b8d-815b-bf0fb024e033',

  feedbackFormUrl: 'https://forms.office.com/e/eyQTVM9Z4W',

  termsOfUseChinaPath:
    'en/SeSO_Portal/TermsOfUseChina.pdf',
};
